import ChristmasHeaderIcon from '@/assets/images/christmas/licences-header-icon.png'

import { LicensesPageChristmasLabel } from './licenses-page-label'

// 27th of December, 08:59 CET
export const CHRISTMAS_CAMPAIGN_END = Date.UTC(
  new Date().getFullYear(),
  11,
  27,
  8,
  59,
  59,
)

// 31st of December, 23:59 UTC
export const CHRISTMAS2025_CAMPAIGN_END = Date.UTC(
  new Date().getFullYear(),
  11,
  31,
  23,
  59,
  59,
)

export const CHRISTMAS_DISCOUNT = 50

export const christmasBackgroundByWindowSize = {
  1500: (
    <div className="flex -translate-x-[28%] items-center gap-8">
      <LicensesPageChristmasLabel className="max-w-[416px]" />
      <img
        src={ChristmasHeaderIcon}
        alt="header icon"
        className="max-w-[165px]"
      />
    </div>
  ),
  1160: (
    <div className="flex flex-col items-center gap-2">
      <div className="flex h-[112px] items-center justify-center">
        <img
          src={ChristmasHeaderIcon}
          alt="header icon"
          className="w-[165px]"
        />
      </div>
      <LicensesPageChristmasLabel className="-mt-[20px] h-[37px] max-w-[330px]" />
    </div>
  ),
  749: (
    <img
      src={ChristmasHeaderIcon}
      alt="header icon"
      className="max-w-[179px] translate-x-[27%]"
    />
  ),
  0: (
    <div className="bottom-0 left-1/2 top-auto h-full max-h-[220px] w-full -translate-x-1/2 translate-y-0 px-12">
      <img
        src={ChristmasHeaderIcon}
        alt="header icon"
        className="h-full w-full"
      />
    </div>
  ),
} as const
